import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Message from '../../../common/Message';
import { messageMaker } from '../../../../helpers/ProductHelper';
import { useProductMessageStyles } from './styles';

const ProductMessage = ({ ...props }) => {
  const {
    type,
    rounded,
    mobile,
    fullRounded,
    hasInfoBelow,
    predefineMessage,
  } = props;
  const classes = useProductMessageStyles({ mobile });
  const message = messageMaker(type);

  return (
    <Box className={classes.container}>
      <Message
        message={predefineMessage || message.message}
        severity={message.severity}
        rounded={rounded}
        fullRounded={fullRounded}
        hasInfoBelow={hasInfoBelow}
        infoBelow={message?.terms || false}
      />
    </Box>
  );
};

ProductMessage.propTypes = {
  type: PropTypes.string,
  rounded: PropTypes.bool,
  mobile: PropTypes.bool,
  fullRounded: PropTypes.bool,
  hasInfoBelow: PropTypes.bool,
  predefineMessage: PropTypes.string,
};

export default ProductMessage;
